import Papa from "papaparse"; // For parsing CSV data
import ReactToPrint from 'react-to-print';
import Schema from "../../schema";
import "./billing.css";
import * as React from "react";
import Box from "@mui/material/Box";
import ItemCard from "../../component/card/productCard";
import Paper from "@mui/material/Paper";
import { Button, IconButton, TextField, Typography } from "@mui/material";
import Modal from "../../component/modal";
import Cash from "./onlinePopup";
import Ofline from "./oflinePopup";
import { useDispatch, useSelector } from "react-redux";
import { BillingInterface } from "../../Interface/ProductsInterface";
import { useBillingStyles } from "../pagesUtils/useBillingStyles";
import { RootState, RootStateBillingProduct } from "../../Interface/BillerIdInterface";
import { ClearAll } from "@mui/icons-material";
import EditIcon from '@mui/icons-material/Edit';
import { creatOrder, getCustomernamebynumber } from "./action";
import { Form, Formik } from "formik";
import Utils from "../../utility";
import Dialog from '@mui/material/Dialog';
import CustomerDetailsForm from "./CustomerDetailsForm";
import CloseIcon from '@mui/icons-material/Close';
import { clearCustomerDetails, clearInvoiceDetails } from "./reducer";
import Grid from "@mui/material/Grid";

export default function Index() {
  const [onlinePinValue, setOnlinePinValue] = React.useState<string>("");
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [buttonClicked, setButtonClicked] = React.useState(false);
  const { storeId: StoreID } = useSelector((state:any) => state.commonReducer);
  const {billerIdData} = useSelector((state: RootState) => state.loginReducer);
  const {customerName, customerNumber,customerCompany,customerGst,customerDetails} = useSelector((state:any)=> state.productsReducer)
  const [customerOpen, setCustomerOpen] = React.useState(false);

  const handleClickOpen = () => {
    setCustomerOpen(true);
  };

  const handleClose = () => {
    setCustomerOpen(false);
  };

  const dispatch: any = useDispatch();
  const { pin } = useSelector((state: any) => state.productsReducer);
  const classes = useBillingStyles();
  const [barcode, setBarcode] = React.useState("");
  const [open, setOpen] = React.useState<string>("");
  const [isOnline, setIsonline] = React.useState<boolean>(false);
  const { products } = useSelector(
    (state: RootStateBillingProduct) => state.productsReducer
  );
  // const [addedProduct, setAddedProduct] = React.useState<any[]>(
  //   []
  // );
  const [addedProduct, setAddedProduct] = React.useState<any>([]);
  
  const [grandTotal, setGrandTotal] = React.useState<number>(0);
  const [total, setTotal] = React.useState<number>(0);
  const [cashReceive, setCashReceive] = React.useState<string | number | any>("");
  const [cashReturn, setCashReturn] = React.useState<string | number>("");
  const [discounPersentage, setDiscountPercentage] = React.useState<number>(0);
  const [discounAmount, setDiscountAmount] = React.useState<number>(0);
  const inputRef = React.useRef<any>(0)

  // React.useEffect(() => {
  //   const storedDataString = localStorage.getItem('csvData');
  //   console.log(storedDataString,"storedDataString")
  // const storedData = storedDataString ? JSON.parse(storedDataString) : [];
  // console.log(storedData)
  //   const testuiop = storedData.map((item)=>{
  //     const newObj = {
  //       id: item.productid,
  //       name: item.name,
  //       brandName: item?.brandName,
  //       sellingPrice: item.sellingprice,
  //       image: item?.image,
  //       quantity: 0,
  //     };
  //     return newObj
  // })
  //   setAddedProduct(testuiop)
  //   // console.log(addedProduct,"Added")
  // }, []);

  React.useEffect(() => {
    const storedDataString = localStorage.getItem('csvData');
    console.log(storedDataString, "storedDataString");
  
    // Only proceed if data exists in localStorage
    if (storedDataString!==null) {
      console.log("rinning")
      const storedData = JSON.parse(storedDataString);
      console.log(storedData, "Parsed Data");
  
      const testuiop = storedData.map((item) => ({
        id: item.productid,
        name: item.name,
        brandName: item?.brandName,
        sellingPrice: item.sellingprice,
        image: item?.image,
        quantity: 0,
      }));
      
  console.log(testuiop)
      setAddedProduct(testuiop);
      console.log(addedProduct,"Added")
    }
  }, []); // Runs only once when the component mounts
  
  // React.useEffect(() => {
  //   console.log(addedProduct, "Added from second use effect");
  // }, [addedProduct]);

  console.log(addedProduct, "Added from second use effect");



  // console.log(addedProduct,"Added")

  React.useEffect(()=>{
return ()=>{
  dispatch(clearCustomerDetails())
}
  },[dispatch])

  const increaseQuantity = (key: number) => {
    setApiSuccess(false); 
    const updateProduct = addedProduct.map((item: any) => {
      // eslint-disable-next-line
      if (Number(item.id) === Number(key)) {
        const newArray = { ...item, quantity: ++item.quantity };
        setBarcode("")
        return newArray;
      } else {
        setBarcode("")
        return item;
      }
    });
    setAddedProduct([...updateProduct]);
  };

  const updateProductAmount = (key:any,newAmount:any) => {
    const updateProduct = addedProduct.map((item: any) => {
      // eslint-disable-next-line
      if (item.id === key) {
        const newArray = { ...item, sellingPrice: newAmount };
        setBarcode("")
        return newArray;
      } else {
        setBarcode("")
        return item;
      }
    });
    setAddedProduct([...updateProduct]);
  };

  const decreaseQuantity = (key: number) => {
    const updateProduct = addedProduct
      .map((item: any) => {
        if (item.id === key) {
          if (item.quantity === 1) {
            // Set the quantity to 0, but don't remove the item from the array
            return { ...item, quantity: 0 };
          }
          // Reduce quantity without modifying the original item directly
          return { ...item, quantity: item.quantity - 1 };
        }
        return item; // Return other items as is
      });
  
    setAddedProduct([...updateProduct]);
  };
  
  const shouldScroll = addedProduct.length > 5;

  React.useEffect(() => {
    if (!addedProduct || addedProduct.length === 0) return; 
    let total: number = 0;
    addedProduct.forEach((singleTotal: BillingInterface) => {
      total = total + Number(singleTotal?.sellingPrice) * singleTotal?.quantity;
    });

    if (discounAmount) {
      // eslint-disable-next-line
      {
        pin?.walletBalance > 0 &&
        pin?.walletBalance !== undefined &&
        pin?.walletBalance !== "NaN"
          ? setGrandTotal(
              total + pin?.walletBalance - (total * discounPersentage) / 100
            )
          : setGrandTotal(total - (total * discounPersentage) / 100);
      }
      // setGrandTotal(total -(total * discounPersentage) / 100);
      setDiscountAmount((total * discounPersentage) / 100);
      // setGrandTotal(total - discounAmount);
    } else {
      // eslint-disable-next-line
      {
        pin?.walletBalance > 0 &&
        pin?.walletBalance !== undefined &&
        pin?.walletBalance !== "NaN" && inputRef?.current?.value
          ? setGrandTotal(total - inputRef?.current?.value)
          : setGrandTotal(total);
      }
      // setGrandTotal(total);
    }
    setTotal(total);
    // eslint-disable-next-line
  }, [addedProduct, pin?.walletBalance]);


  const handleChnageCashReceive = (e: any) => {
    const receive = e.target.value;
    setCashReceive(receive);
    setCashReturn(receive - grandTotalEnd);
  };

  const handleChnageCashReturn = (e: any) => {
    const returnCash = e.target.value;
    setCashReturn(returnCash);
  };

  const totalItems = addedProduct.reduce((acc, item) => Number(acc) + Number(item.quantity), 0);  
  const grandTotalEnd = addedProduct
  .filter(item => Number(item.quantity) > 0) // Filter products with quantity > 0
  .reduce(
    (acc, item) => acc + Number(item.quantity) * Number(item.sellingPrice), 
    0
  );

  const initialValues = {
    phoneNumber: "",
    customerName: "",
    gst:"",
    companyName:"",
    address:"",
    email:"",
    customerPhone:0
  };

  const newhandleChangePhone =(e: any, setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void) => {
    if(e.target.value.length===10){
      setIsDisabled(false)
      dispatch(getCustomernamebynumber(e.target.value, setFieldValue,setIsDisabled))
    }
  }

  const filterProduct = addedProduct?.map((a:any)=>a.quantity>0&&a)

  const lastFinalProduct = filterProduct.filter(Boolean)

  const totalAndDiscounts = {grandTotal, discounPersentage, discounAmount}
  let test = {customerName,customerNumber,customerCompany,customerGst}

    const [savedCartCheck, setSavedCartCheck] = React.useState(false);
    const [currentCart, setCurrentCart] = React.useState('Cart 1');
    const [apiSuccess,setApiSuccess] = React.useState(false);

    const invoiceHtml = useSelector((state: any) => state.productsReducer.invoiceHtml);
    const componentRef = React.useRef<HTMLDivElement>(null);
    const reactToPrintTrigger = React.useRef<any>();
  
    React.useEffect(() => {
      if (invoiceHtml && reactToPrintTrigger.current) {
        reactToPrintTrigger.current.handlePrint();
      }
    }, [invoiceHtml]);

    const handleClearInvoiceHtml = () => {
      dispatch(clearInvoiceDetails())
    };

    // React.useEffect(() => {
    //   if(StoreID){
    //     fetch(`https://newshopazure.blob.core.windows.net/newshopdev/newshop/${StoreID}.csv`)
    //     // fetch(`https://quickpos.s3.ap-south-1.amazonaws.com/${StoreID}.csv`)
    //     .then(response => response.text())
    //     .then(csvData => {
    //       console.log(csvData,"csv")
    //       Papa.parse(csvData, {
    //         header: true,
    //         complete: function (results) {            
    //           localStorage.setItem("csvData", JSON.stringify(results.data));
    //         },
    //         error: function (error) {
    //           console.error("Error parsing CSV file: ", error);
    //         }
    //       });
    //     })
    //     .catch(error => {
    //       console.error("Error fetching CSV file: ", error);
    //     });
    //   }
    // }, [StoreID]);

    React.useEffect(() => {
      const storedCart2 = localStorage.getItem("cart2");
      if (storedCart2) {
        setSavedCartCheck(true);
      } else {
        setSavedCartCheck(false);
      }
    }, []);

    const [currentItems, setCurrentItems] = React.useState<any[]>([]);
    const [hasMore, setHasMore] = React.useState(true);
    const [page, setPage] = React.useState(1);
    const itemsPerPage = 50;
  
    // Load initial items
    React.useEffect(() => {
      if (addedProduct && addedProduct.length > 0) {
        const initialItems = addedProduct.slice(0, itemsPerPage);
        setCurrentItems(initialItems);
      }
    }, [addedProduct]);
  
    // Infinite scroll handler
    const handleScroll = (e: any) => {
      const { scrollHeight, scrollTop, clientHeight } = e.target.scrollingElement;
      
      if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore) {
        loadMoreItems();
      }
    };
  
    // Load more items when user scrolls to the bottom
    const loadMoreItems = () => {
      const nextPage = page + 1;
      const startIndex = nextPage * itemsPerPage - itemsPerPage;
      const endIndex = nextPage * itemsPerPage;
      const moreItems = addedProduct.slice(startIndex, endIndex);
  
      if (moreItems.length > 0) {
        setCurrentItems(prevItems => [...prevItems, ...moreItems]);
        setPage(nextPage);
      } else {
        setHasMore(false); // No more items to load
      }
    };
  
    // Add event listener for infinite scroll
    React.useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [hasMore, page, addedProduct]);

  return (
    <Box>
      {invoiceHtml && (
   <ReactToPrint
   content={() => componentRef.current}
   ref={reactToPrintTrigger}
   onAfterPrint={handleClearInvoiceHtml} 
 />
      )}

      {invoiceHtml && (
        <div 
        id="invoice-printable"
        ref={componentRef} dangerouslySetInnerHTML={{ __html: invoiceHtml }} />
      )}
 <Box sx={{ mt: 2, width: "70%" }}> {/* Keep container width at 70% */}
  <Grid
    container
    spacing={2}  // Space between each card
    justifyContent="center"  // Center the grid items
    alignItems="center"
  >
    {currentItems.map((card: any) => (
      <Grid
        item
        key={card?.id}
        xs={6}  // 2 items per row on small screens (phones)
        sm={4}  // 3 items per row on medium screens (tablets)
        md={2}  // Approx. 7 items per row on large screens to increase width
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 8px", // Adjust padding if needed
        }}
      >
        <Box
          sx={{
            width: "450px", // Full width of the grid item
            maxWidth: "300px", // Set a maximum width for each product card
            height: "250px",
            backgroundColor: "white", 
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            padding: "8px",
            textAlign: "center",
            transition: "transform 0.3s",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          <ItemCard
            id={card?.id}
            image={card?.image}
            productName={card?.name}
            quantity={card?.quantity}
            price={card?.sellingPrice}
            sellingPrice={card?.sellingPrice}
            increaseQuantity={() => increaseQuantity(card?.id)}
            decreaseQuantity={() => decreaseQuantity(card?.id)}
            originalQuantity={card?.quantity}
            updateProductAmount={updateProductAmount}
            brandName={card?.brandName}
          />
        </Box>
      </Grid>
    ))}
  </Grid>
</Box>

      <Box>
        {apiSuccess===false ? (
          <Paper
            sx={{
              width: { xs: '100%', sm: 280, md: 350 }, 
              position: "fixed",
              top: 0,
              bottom: 0,
              right: 0,
              zIndex: 99,
              padding: 2,
            }}
          >
            <Box sx={{ position: "relative", height: "97vh" }}>
                <>
<div style={{
    display: 'flex', 
    justifyContent: 'flex-start', 
    alignItems: 'center', 
}}>
    <div
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }}
  onClick={() => {
    const cartKey = currentCart === "Cart 1" ? "cart1" : "cart2";
    localStorage.removeItem(cartKey);
    // setAddedProduct([])
    setAddedProduct(prevProducts =>
      prevProducts.map(product => ({
        ...product,
        quantity: 0 // Reset quantity to 0
      }))
    );
    dispatch(clearCustomerDetails())
  }}
>
  <ClearAll />
  <Typography variant="body1" style={{ fontWeight: 'bold', marginLeft: 8 }}>
        Clear Cart
      </Typography>
</div>


</div>
<Formik
  enableReinitialize
  initialValues={initialValues}
  validationSchema={Schema.offlineCashCollectPopup}
  onSubmit={(values) => {
    dispatch({
      type: Utils.ActionName.PRODUCTS,
      payload: {
        customerName: values.customerName,
        customerNumber: values.customerPhone, 
      }
    });
  }}
>
  {({
    values,
    errors,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
  }) => (
    <Form onSubmit={handleSubmit}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '5px',
          marginTop: '10px',
          marginBottom: '20px',
        }}
      >
        {customerName ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              padding: '10px',
              backgroundColor: '#DEE0E8',
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="body1">
                <span style={{ fontWeight: 'bold', fontSize: '17px' }}>
                  {customerDetails.name || customerName}
                </span>
                {" | "}
                {customerDetails.number || customerNumber}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '16px' }}>
                {customerDetails.company || customerCompany} {customerDetails.gst || customerGst && "|"} {customerDetails.gst || customerGst}
              </Typography>
            </Box>
            <Box>
              <Button
                sx={{
                  minWidth: 'auto',
                  padding: '5px',
                }}
                onClick={handleClickOpen}
              >
                <EditIcon sx={{ color: 'black', fontSize: 30 }} />
              </Button>
            </Box>
          </Box>
        ) : (
          <>
          </>
        )}
      </Box>
    </Form>
  )}
</Formik>
<Dialog 
open={customerOpen}
onClose={handleClose}
maxWidth="sm"
fullWidth
sx={{
  '& .MuiDialog-paper': {
    borderRadius: '12px', // Slight curve to the dialog borders
  },
}}
>
<IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
          <CustomerDetailsForm 
            customerName={customerName} 
            customerNumber={customerNumber}
             customerCompany={customerCompany}
              customerGst={customerGst}
              setOpen={setOpen}
              setCustomerOpen={setCustomerOpen}
              />
      </Dialog>
      <Box
  sx={{
    maxHeight: shouldScroll ? '50vh' : 'unset', // Match maxHeight to 50vh
    overflowY: shouldScroll ? 'auto' : 'auto', // Use 'auto' for scrollbar only when needed
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '12px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: '10px',
      border: '3px solid #f1f1f1',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#bbb',
    },
    padding: '10px',
    height: '35vh', // Set height to 30vh (previously 50vh) for visible area
  }}
>
  {
    addedProduct?.map((item, index) => {
      if (item.quantity > 0) {
        return (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '2px dotted black', // Dotted border instead of solid divider
              }}
            >
              <Box sx={{ flex: 3 }}> {/* 60% space */}
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {item.name}
                </Typography>
                <Typography variant="body2">
                  Rs.{Math.round(item.sellingPrice)} | Barcode: {item.barcode} | GST: {item.gst}%
                </Typography>
              </Box>
              <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}> {/* 20% space */}
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  x {item.quantity}
                </Typography>
              </Box>
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}> {/* 20% space */}
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  Rs. {parseInt(item.sellingPrice) * item.quantity}
                </Typography>
              </Box>
            </Box>
          </React.Fragment>
        );
      }
      return null;
    })}
</Box>
                </>
              <Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    position: 'sticky', // Sticky positioning for subtotal and grand total
    bottom: 0, // Fixes the position at the bottom
    zIndex: 10, // Ensures it stays on top of other content
    background: 'white', // Adds background to avoid overlap issues
    padding: '10px', // Padding for better visual separation
  }}
>
  {/* Subtotal */}
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '2px dotted black',
      marginTop:"20px"
    }}
  >
    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
      Sub Total
    </Typography>
    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
      {totalItems} items
    </Typography>
    <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
      Rs.{Math.round(grandTotalEnd)}
    </Typography>
  </Box>
  <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    borderBottom: '2px dotted black',
    width: '100%',
  }}
>
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
      Discount
    </Typography>
  </Box>
  
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
    }}
  >
    <TextField
    // disabled={!debug.length || !reversedArray.length}
      variant="standard"
      name="discountPercent"
      type="text"
      placeholder="amount"
      value={Math.round(discounPersentage)}
      // onChange={handleChangeDiscountPercentage}
      size="small"
      InputProps={{ disableUnderline: true }}
      sx={{
        width: '60px', // Adjust width to ensure proper spacing
        marginRight: '8px',
        '& .MuiInputBase-input': {
          fontWeight: 'bold',
          fontSize: '1.1rem',
          textAlign: 'center',
          padding: '0',
          lineHeight: '1.5',
        },
      }}
    />
    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
      %
    </Typography>
  </Box>
  
  <Box
  sx={{
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    whiteSpace: 'nowrap',
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 'bold',
      fontSize: '1.1rem',
    }}
  >
    Rs.
  </Typography>
  <TextField
    variant="standard"
    name="discountAmount"
    type="text"
    value={Math.round(discounAmount)}
    placeholder="amount"
    // onChange={handleChangeDiscountAmount}
    size="small"
    InputProps={{ disableUnderline: true }}
    sx={{
      width: '60px', // Adjust width to ensure proper spacing
      '& .MuiInputBase-input': {
        fontWeight: 'bold',
        fontSize: '1.1rem',
        textAlign: 'right',
        padding: '0',
        lineHeight: '1.5',
        margin: 0,
      },
    }}
  />
</Box>
</Box>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Typography variant="h5" style={{ fontWeight: 'bold' }}>
      Grand Total
    </Typography>
    <Typography component="div" className={classes.amount} style={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
      Rs. {Math.round(grandTotalEnd)}
    </Typography>
  </Box>
</Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '5px',
          marginTop: '10px',
          marginBottom: '20px',
        }}
      >
            <Box sx={{ width: '100%', maxWidth: '100%'}}>
              <TextField
              type="number"
                variant="outlined"
                label="Cash Received"
                size="small"
                name="cashReceived"
                onChange={handleChnageCashReceive}
                InputLabelProps={{ style: { color: 'black' } }}
                InputProps={{
                  placeholder: 'Cash Received',
                  sx: {
                    borderRadius: '10px',
                  },
                }}
              />
            </Box>
            <Box sx={{ width: '100%', maxWidth: '100%'}}>
              <TextField
                value={cashReceive ? cashReturn : ""}
                variant="outlined"
                label="Return"
                size="small"
                name="return"
                onChange={handleChnageCashReturn}
                InputLabelProps={{ 
                  shrink: !!cashReturn || cashReceive !== 0,
                  style: { color: 'black' } 
                }}
                InputProps={{
                  placeholder: 'Return',
                  sx: {
                    borderRadius: '10px',
                  },
                }}
              />
            </Box>  
      </Box>
        {/* </Box> */}
  {addedProduct?.map(
    (a: BillingInterface) =>
      a.quantity > 0 && (
        <>
<Box
  sx={{
    position: "absolute",
    bottom: 0,
    width: '100%',
    mt: 2,
    // p: 2,
  }}
>
  {/* Top 3 payment options */}
  <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 1.5,
    mb: 2,
    px: 2, // Padding to ensure spacing from edges
  }}
>
  <Typography
    className={classes.cashCollectMethod}
    onClick={() => {
      // if (buttonClicked) return;
      dispatch(
        creatOrder(
          test,
          lastFinalProduct,
          totalAndDiscounts,
          setOpen,
          "cash",
          onlinePinValue,
          setAddedProduct,
          billerIdData,
          setBarcode,
          setIsDisabled,
          setDiscountPercentage,
          setDiscountAmount,
          setButtonClicked,
          StoreID,
          setCashReceive,
          setCashReturn,
          setApiSuccess,
          currentCart,
          setCurrentCart,
          grandTotalEnd
          // testChangeCart
        )
      );
    }}
  >
    Cash
  </Typography>

  <Typography
    className={classes.cashCollectMethod}
    onClick={() => {
      // if (buttonClicked) return;
      dispatch(
        creatOrder(
          test,
          lastFinalProduct,
          totalAndDiscounts,
          setOpen,
          "card",
          onlinePinValue,
          setAddedProduct,
          billerIdData,
          setBarcode,
          setIsDisabled,
          setDiscountPercentage,
          setDiscountAmount,
          setButtonClicked,
          StoreID,
          setCashReceive,
          setCashReturn,
          setApiSuccess,
          currentCart,
          setCurrentCart,
          grandTotalEnd
          // testChangeCart
        )
      );
    }}
  >
    Card
  </Typography>

  <Typography
    className={classes.cashCollectMethod}
    onClick={() => {
      // if (buttonClicked) return;
      dispatch(
        creatOrder(
          test,
          lastFinalProduct,
          totalAndDiscounts,
          setOpen,
          "card",
          onlinePinValue,
          setAddedProduct,
          billerIdData,
          setBarcode,
          setIsDisabled,
          setDiscountPercentage,
          setDiscountAmount,
          setButtonClicked,
          StoreID,
          setCashReceive,
          setCashReturn,
          setApiSuccess,
          currentCart,
          setCurrentCart,
          grandTotalEnd
          // testChangeCart
        )
      );
    }}
  >
    UPI
  </Typography>
</Box>
{/* Bottom 2 payment options centered */}
<Box
   sx={{
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 1.5,
    mb: 2,
    px: 2, // Padding to ensure spacing from edges
  }}
  >
    <Typography
      className={classes.cashCollectMethod}
      onClick={() => {
        setIsonline(true);
        setOpen("online");
      }}
    >
      Online
    </Typography>

    <Typography
      className={classes.cashCollectMethod}
      onClick={() => {
        if (buttonClicked) return;
        if (customerNumber) {
          dispatch(
            creatOrder(
              test,
              lastFinalProduct,
              totalAndDiscounts,
              setOpen,
              "credit",
              onlinePinValue,
              setAddedProduct,
              billerIdData,
              setBarcode,
              setIsDisabled,
              setDiscountPercentage,
              setDiscountAmount,
              setButtonClicked,
              StoreID,
              setCashReceive,
              setCashReturn,
              setApiSuccess,
              currentCart,
              setCurrentCart,
              // testChangeCart
            )
          );
        } else {
          Utils.showAlert(2, "Enter Customer Details");
        }
      }}
    >
      Credit
    </Typography>

    <Typography
      className={classes.cashCollectMethod}
      // onClick={handleSplitOpen}
    >
      Split
    </Typography>
  </Box>
</Box>

        </>
      )
  )}
            </Box>
          </Paper>
        ) : (
          <></>
        )}
      </Box>
      <Modal
        header="Billing"
        children={
          isOnline ? (
            <Cash
              open={open}
              setOpen={setOpen}
              addedProduct={addedProduct}
              setAddedProduct={setAddedProduct}
              totalAndDiscounts={{
                grandTotal: grandTotal,
                discounPersentage,
                discounAmount,
              }}
              // barcode={barcode}
              setBarcode={setBarcode}
              setDiscountPercentage={setDiscountPercentage}
            setDiscountAmount={setDiscountAmount}
            customerName={customerName}
            customerNumber={customerNumber}
            customerCompany={customerCompany}
            customerGst={customerGst}
            />
          ) : (
            <Ofline
              open={open}
              setOpen={setOpen}
              setAddedProduct={setAddedProduct}
              addedProduct={addedProduct}
              totalAndDiscounts={{
                grandTotal: grandTotal,
                discounPersentage,
                discounAmount,
              }}
              setBarcode={setBarcode}
              wallet={inputRef?.current?.value}
              setDiscountPercentage={setDiscountPercentage}
              setDiscountAmount={setDiscountAmount}
              customerName={customerName}
              customerNumber={customerNumber}
              customerCompany={customerCompany}
              customerGst={customerGst}
              setCustomerOpen={setCustomerOpen}
            />
          )
        }
        handleClose={() => {
          setOpen("");
          setIsonline(false);
        }}
        open={open}
      />
    </Box>
  );
}